import { Outlet } from 'react-router-dom';
import Footer from '../Footer';
import AdminHeader from '../Header/AdminHeader';
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react'
import { IsTokenExpired } from '../../helpers/lib/jwt';

export default function AdminLayout() {
  const navigate = useNavigate()
  const token = Cookies.get('noohraToken')

  useEffect(() => {
    if (!token) {
      navigate('/signup')
      return;
    }
    if (IsTokenExpired(token)) {
      Cookies.remove("noohraToken");
      navigate("/signup");
      console.log('token expired')
      return;
    }
  }, [navigate, token])

  return (
    <>
      <AdminHeader logoSrc="/noohra.png" variant="cs_heading_color" />
      <Outlet />
      <Footer />
    </>
  );
}
